import HTTP_REQUEST from "../../utils/http";
import url from "../../utils/url";
import * as tokenTypes from "../types/token";
import { changeGlobalState } from "./global";
import helpers from "../../utils/helpers";

export const cleanToken = () => ({
    type: tokenTypes.CLEAN_TOKEN,
});

export const sendToken = (data) => ({
    type: tokenTypes.SEND_TOKEN,
    data,
});

const ERROR_STATE = 4;

export const getToken = (data) => async (dispatch) => {
  try {
    dispatch(cleanToken());
    const response = await HTTP_REQUEST.AmplifyApi({
      name: "APIS_SESSION",
      path: url.pagoSession,
      data: {
        body: {
          payload: data,
        },
      },
    });

    const session = response?.payload?.sesion;
    if (session?.token) {
      dispatch(sendToken(session.token));
    } else {
      dispatch(changeGlobalState(ERROR_STATE));
    }
  } catch (error) {
    helpers.sendTagError(error, url.pagoSession);
    dispatch(changeGlobalState(ERROR_STATE));
  }
};